import { render, staticRenderFns } from "./RealPositions.vue?vue&type=template&id=04bdf44f&scoped=true&"
import script from "./RealPositions.vue?vue&type=script&lang=js&"
export * from "./RealPositions.vue?vue&type=script&lang=js&"
import style0 from "./RealPositions.vue?vue&type=style&index=0&id=04bdf44f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bdf44f",
  null
  
)

export default component.exports